<template>
  <div
    v-if="content"
    class="homeCard"
    :class="{ 'reverse': content.reverse }"
  >
    <div
      class="indexProject"
      :style="{ width: `${customWidth01}` + '%' }"
    >
      <div class="indexProject__content">
        <InertiaLink
          v-if="thumbnailRatio[0]"
          class="indexProject__image-container"
          :href="`/work/${content.project.slug}/`"
        >
          <img
            v-if="thumbnailRatio[0]"

            :data-src="getImageKitURL(thumbnailRatio[0], 1.5, content.project.image_type,false,position)"
            :src="getImageKitURL(thumbnailRatio[0], 1.5, content.project.image_type,true,position)"
            :alt="content.project.title"
            class="indexProject__image"
          >
        </InertiaLink>
        <InertiaLink
          :href="`/work/${content.project.slug}/`"
          class="indexProject__text"
        >
          <p class="indexProject__client">
            {{ content.project.client_subtitle }}
          </p>
          <h3 class="indexProject__title">
            {{ content.project.title }}
          </h3>
          <p class="indexProject__subtitle">
            {{ content.project.subtitle }}
          </p>
        </InertiaLink>
      </div>
    </div>
    <div
      class="indexProject homeCard__main"
      :style="{ width: `${customWidth02}` + '%' }"
    >
      <div
        v-if="content.include_animated_texts"
        class="homeCard__animated"
      >
        <div
          v-if="animatedTextMessages.length"
          ref="animatedSlideContentEl"
          class="homeCard__text homeCard__animated--content"
          v-html="animatedTextMessages[animatedSlideIndex]"
        />
      </div>
      <div
        v-else
        class="homeCard__single homeCard__text"
        v-html="content?.text"
      />
    </div>
  </div>
</template>

<script>
import imageKit from "@/mixins/image-kit";
import { InertiaLink } from "@inertiajs/inertia-vue3";

export default {
  components: {
    InertiaLink,
  },
  mixins: [imageKit],

  props: {
    position:{
      type: Number,
      default: 1000
    },
    content: {
      type: Object,
      default: () => {},
    },

  },

  data() {
    return {
      animatedSlideIndex: 0,
      animatedSlideDelayCall: null,
    };
  },

  computed: {
    thumbnailRatio() {
      if(this.$store.state.isMobile) {
        return [this.content.project.thumbnail_4_5, this.content.project.thumb_4_5_video];
      } else {
        switch (this.content.thumbnail_ratio) {
          case "square":
            return [this.content.project.square_thumbnail, this.content.project.thumb_1_1_video];
            break;
          case "sixteen-by-seven":
            return [this.content.project.thumbnail_16_7, this.content.project.thumb_16_7_video];
            break;
          case "four-by-five":
            return [this.content.project.thumbnail_4_5, this.content.project.thumb_4_5_video];
            break;

          default:
            return [this.content.project.thumbnail_16_9, this.content.project.thumb_16_9_video];
            break;
        }
      }
    },

    customWidth01() {
      if(this.$store.state.isMobile) {
        return 100;
      } else {
        return this.content.card_width;
      }
    },

    customWidth02() {
      if(this.$store.state.isMobile) {
        return 100;
      } else {
        return 100 - this.content.card_width;
      }
    },

    /** Raw bard HTML per grid row (`animated_text`). */
    animatedTextMessages() {
      const rows = this.content?.animated_texts;
      if (!Array.isArray(rows) || !rows.length) {
        return [];
      }
      return rows
        .map((row) => row?.animated_text)
        .filter((h) => typeof h === "string" && h.trim().length > 0);
    },
  },

  watch: {
    "content.include_animated_texts"(on) {
      if (on) {
        this.$nextTick(() => this.runAnimatedSlideLoop());
      } else {
        this.stopAnimatedSlideLoop();
      }
    },
    animatedTextMessages: {
      handler() {
        this.animatedSlideIndex = 0;
        if (this.content?.include_animated_texts) {
          this.$nextTick(() => this.runAnimatedSlideLoop());
        }
      },
      deep: true,
    },
  },

  mounted() {
    if (this.content?.include_animated_texts && this.animatedTextMessages.length) {
      this.$nextTick(() => this.runAnimatedSlideLoop());
    }
  },

  beforeUnmount() {
    this.stopAnimatedSlideLoop();
  },

  methods: {
    stopAnimatedSlideLoop() {
      if (this.animatedSlideDelayCall) {
        this.animatedSlideDelayCall.kill();
        this.animatedSlideDelayCall = null;
      }
      const el = this.$refs.animatedSlideContentEl;
      if (el) {
        this.$gsap.killTweensOf(el);
      }
    },

    runAnimatedSlideLoop() {
      this.stopAnimatedSlideLoop();
      const el = this.$refs.animatedSlideContentEl;
      const slides = this.animatedTextMessages;
      if (!el || !slides.length) {
        return;
      }

      const gsap = this.$gsap;
      const hold = 4.5;

      const show = () => {
        gsap.killTweensOf(el);
        gsap.set(el, { opacity: 0 });
        gsap.to(el, {
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          onComplete: () => {
            this.animatedSlideDelayCall = gsap.delayedCall(hold, hideAndAdvance);
          },
        });
      };

      const hideAndAdvance = () => {
        gsap.to(el, {
          opacity: 0,
          duration: 1,
          ease: "power2.in",
          onComplete: () => {
            this.animatedSlideIndex =
              (this.animatedSlideIndex + 1) % slides.length;
            this.$nextTick(() => {
              show();
            });
          },
        });
      };

      show();
    },
  },

  // mounted(){
  //   this.$nextTick(() => this.$store.commit("TOGGLE_BG_BACKGROUND_HOME", true));
  // },
};
</script>

<style lang="scss">
.homeCard {
  width: 100%;
    display: flex;
  flex-wrap: wrap;

  @include tablet {
    @include paddingMedium;

     flex-wrap: nowrap;

    &.reverse {
      flex-direction: row-reverse;
    }
  }

  &__main {
    display: flex;
    justify-content: center;

    @include paddingMobile;




    @include tablet {
         align-items: center;
      padding: 0;
      aspect-ratio: initial;

    }
  }

  &__animated {
    display: flex;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
    // position: relative;
    // padding-top: 40%;
    height: 100%;
    width: 100%;
    aspect-ratio: 1/1;


    // @include tablet {
    //     padding-top: 26%;
    //     padding-left: 6vw;
    // }
    //  @include desktop-sm {
    //     padding-left: 10vw;
    // }
    // @include desktop-xl {
    //     padding-left: 12vw;
    // }
    @include tablet {
      width: fit-content;
      height: fit-content;
      justify-content: center;
      margin-bottom: 110px;
    }

  }

  &__single {
    padding-top:9vh;
     padding-bottom: 9vh;

      @include tablet {
        margin-bottom: 110px;
    }
  }

  &__text {

    * {
        font-size: clamp(1.9rem, 0.8rem + 2.5vw, 4.625rem);
        line-height: 1.2;
        letter-spacing: -1px;
        font-variation-settings: 'wght' 700, 'wdth' 100, 'opsz' 30;

        @include tablet {
          font-size: clamp(1.5rem, 0.75rem + 2.5vw, 4.625rem);
        }
        @include desktop-sm {
           letter-spacing: -2px;
        }


    }

    strong {
      color: $orange;
    }
  }


}
</style>
